import type { FormFieldsData } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import usePositionFillRequestsService from '../../usePositionFillRequestsService';
import { getReviewPositionFillRequestSections } from './reviewPositionFillRequestSections';
import reviewPositionFillRequestValidation from './reviewPositionFillRequestValidation';

type ApprovalDecision = 'APPROVE' | 'REJECT';

type ReviewPositionFillRequestFormValues = {
  decision: ApprovalDecision;
};

type ReviewPositionFillRequestDrawerProps = {
  isOpen: boolean;
  positionFillRequestId: string;
  onClose: () => void;
  onSuccess: () => void;
};

const ReviewPositionFillRequestDrawer = ({
  isOpen,
  positionFillRequestId,
  onClose,
  onSuccess,
}: ReviewPositionFillRequestDrawerProps) => {
  const { makeApprovalDecision } = usePositionFillRequestsService();

  const submitForm = (data: FormFieldsData) => {
    const values = data as ReviewPositionFillRequestFormValues;

    return makeApprovalDecision(positionFillRequestId, values.decision);
  };

  return (
    <CreateEditFormDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Review position fill request"
      header="Review the request details and make a decision. Approving the request will allow the Recruitment team to proceed with hiring for this position."
      width={780}
      initialData={{ decision: '' }}
      submitFormFunc={submitForm}
      submitButtonTitle="Submit"
      getValidationSchemaFunc={() => Promise.resolve(reviewPositionFillRequestValidation)}
      handleDirty={false}
      afterSubmit={{
        execute: () => {
          onSuccess();
          onClose();
        },
        message: 'Position fill request decision has been submitted.',
      }}
      getSections={getReviewPositionFillRequestSections}
    />
  );
};

export default ReviewPositionFillRequestDrawer;
